import React, {useCallback} from "react";

import {useFormik} from "formik";
import {debounce} from "../../../../utils/debounce";
import {onlyDateISOString} from "../../../../services/date/formatters";
import SearchTools from "./SearchTools";
import {useQuotes} from "../../QuotesContext";
import {isValidDateObject} from "../../../../services/date/validators";

import Grid from "@mui/material/Grid";
import {DatePicker} from "@mui/x-date-pickers";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";


const QuoteSearchTools = () => {

    const {setSearchFilters, searchFilters} = useQuotes();

    const handleSubmit = useCallback( // eslint-disable-line react-hooks/exhaustive-deps
        debounce((values) => {
            let data = {}
            if (values["textSearch"] !== null && values["textSearch"] !== "") {
                data["text_search"] = values["textSearch"]
            }
            if (values["arrivalGte"]) {
                data["arrival_gte"] = onlyDateISOString(values["arrivalGte"])
            }
            if (values["departureLte"]) {
                data["departure_lte"] = onlyDateISOString(values["departureLte"])
            }
            if (values["createdByAutoReply"] === "autoReply") {
                data["created_by_auto_reply"] = true
            } else if (values["createdByAutoReply"] === "manual") {
                data["created_by_auto_reply"] = false
            }
            if (values["confirmed"] === true) {
                data["confirmed"] = true
            }
            setSearchFilters(data)
        }, 300),
        []
    )

    const formik = useFormik({
        initialValues: {
            textSearch: searchFilters.text_search || "",
            arrivalGte: searchFilters.arrival_gte ? new Date(searchFilters.arrival_gte) : null,
            departureLte: searchFilters.departure_lte ? new Date(searchFilters.departure_lte) : null,
            createdByAutoReply: searchFilters.created_by_auto_reply  === true ? "autoReply" : searchFilters.created_by_auto_reply === false ? "manual" : "all",
            confirmed: null,
        },
        validationSchema: null,
        onSubmit: handleSubmit
    })

    const handleChange = (e) => {
        formik.handleChange(e);
        formik.submitForm();
    }

    const handleOnConfirmedChange = (e) => {
        if(e.target.checked) {
            formik.setFieldValue("confirmed", true);
        } else {
            formik.setFieldValue("confirmed", null);
        }
        formik.submitForm();
    }

    return <SearchTools InputBaseProps={{
        value: formik.values.textSearch || "",
        placeholder: "Cerca",
        name: "textSearch",
        onChange: handleChange,
        error: formik.touched.textSearch && Boolean(formik.errors.textSearch),
    }}>
        <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                <DatePicker value={formik.values.arrivalGte}
                            onChange={date => {
                                formik.setFieldValue("arrivalGte", date);
                                formik.submitForm();
                            }}
                            label="Data arrivo"
                            closeOnSelect
                            disableHighlightToday
                            showDaysOutsideCurrentMonth
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    required: true,
                                    error: Boolean(formik.touched.arrivalGte) && Boolean(formik.errors.arrivalGte),
                                    helperText: formik.touched.arrivalGte && formik.errors.arrivalGte,
                                    size: "small"
                                }
                            }}
                            />
            </Grid>
            <Grid item xs={12} md={6}>
                <DatePicker value={formik.values.departureLte}
                            onChange={date => {
                                formik.setFieldValue("departureLte", date);
                                formik.submitForm();
                            }}
                            minDate={formik.values.arrivalGte}
                            defaultCalendarMonth={isValidDateObject(formik.values.arrivalGte) ? formik.values.arrivalGte : undefined}
                            label="Data partenza"
                            closeOnSelect
                            disableHighlightToday
                            showDaysOutsideCurrentMonth
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    required: true,
                                    error: Boolean(formik.touched.departureLte) && Boolean(formik.errors.departureLte),
                                    helperText: formik.touched.departureLte && formik.errors.departureLte,
                                    size: "small"
                                }
                            }}/>
            </Grid>
            <Grid item xs={12} md={6}>
                <TextField select
                           fullWidth
                           label="Preventivi visualizzati"
                           value={formik.values.createdByAutoReply}
                           name="createdByAutoReply"
                           onChange={handleChange}
                           size="small">
                    <MenuItem value="all">Tutti</MenuItem>
                    <MenuItem value="autoReply">Creati in automatico</MenuItem>
                    <MenuItem value="manual">Creati a mano</MenuItem>
                </TextField>

            </Grid>
            <Grid item xs={6} md={6}>
                <FormGroup>
                    <FormControlLabel control={<Checkbox onChange={handleOnConfirmedChange}/>} label="Confermati" />
                </FormGroup>
            </Grid>
        </Grid>
    </SearchTools>
}

export default QuoteSearchTools;